<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidades"
                        @change="handleUnidadeChange"
                        label="Unidade municipal"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="infraestrutura.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!infraestrutura.unidadeId"
                        :options="infraestruturas"
                        :validations="validations.infraestruturaId"
                        @change="handleInfraestruturaChange"
                        label="Local de atendimento municipal"
                        show-default-option
                        text-field="nome"
                        v-model="infraestrutura.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="9">
                    <rkm-form-input
                        :disabled="infraestrutura.principal"
                        :validations="validations.nome"
                        label="Nome"
                        v-model="infraestrutura.nome"
                        uppercase
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    inline
                                    v-model="infraestrutura.principal"
                                    :disabled="disabledCheckboxPrincipal"
                                >
                                    Principal
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        v-if="['', null, undefined].includes(infraestrutura.telefone)"
                        :validations="validations.telefone"
                        label="Telefone"
                        v-model="infraestrutura.telefone"
                    />

                    <rkm-form-input
                        v-else-if="infraestrutura.telefone.length < 15"
                        :validations="validations.telefone"
                        label="Telefone"
                        v-mask="mask.phone"
                        v-model="infraestrutura.telefone"
                    />

                    <rkm-form-input
                        v-else
                        :validations="validations.telefone"
                        label="Telefone"
                        v-mask="mask.cellPhone"
                        v-model="infraestrutura.telefone"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-select
                        :options="form.estados"
                        :validations="validations.estado"
                        label="UF"
                        v-model="infraestrutura.endereco.estadoId"
                        show-default-option
                        value-field="id"
                        text-field="uf"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :searchFields="form.autocompleteFields.municipio"
                        :repository="repositories.municipio"
                        :requestQueryStringParams="{ estado_id: infraestrutura.endereco.estadoId }"
                        v-model="infraestrutura.endereco.municipio"
                        :validations="validations.municipio"
                        label="Município"
                        :disabled="!infraestrutura.endereco.estadoId"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :searchFields="form.autocompleteFields.logradouro"
                        :repository="repositories.logradouro"
                        :requestQueryStringParams="{
                            municipio_id: infraestrutura.endereco.municipio
                                ? infraestrutura.endereco.municipio.id
                                : null
                        }"
                        v-model="infraestrutura.endereco.logradouro"
                        textField="tipoNome"
                        :validations="validations.logradouro"
                        label="Logradouro"
                        :disabled="!infraestrutura.endereco.municipio"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input
                        :disabled="infraestrutura.endereco.semNumero"
                        :validations="validations.numero"
                        label="Número"
                        v-model="infraestrutura.endereco.numero"
                        number
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox
                                    inline
                                    v-model="infraestrutura.endereco.semNumero"
                                >
                                    Sem número
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.complemento"
                        label="Complemento"
                        v-model="infraestrutura.endereco.complemento"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        disabled
                        label="Bairro"
                        v-model="infraestrutura.endereco.bairroNome"
                        uppercase
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        disabled
                        label="CEP"
                        v-model="infraestrutura.endereco.cep"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.zonas"
                        label="Zona"
                        text-field="descricao"
                        v-model="infraestrutura.endereco.zonaId"
                        value-field="id"
                        :validations="validations.zona"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col
                    cols="6"
                >
                    <rkm-button
                        v-if="index !== null"
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(update)"
                    >
                        Salvar
                    </rkm-button>

                    <rkm-button
                        v-else
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="danger"
                        @click.stop="clear"
                    >
                        {{ index !== null ? 'Cancelar' : 'Limpar' }}
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            :fields="fields"
            :items="model.infraestruturas"
            ref="Table"
            class="my-4"
        >
            <template v-slot:cell(principal)="row">
                {{ row.item.principal ? 'SIM' : 'NÃO' }}
            </template>

            <template v-slot:cell(endereco.numero)="row">
                {{ row.item.endereco.numero || 'S/N' }}
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    color="primary"
                    title="Cadastrar centro de custo"
                    small
                    @click.stop="$refs.ModalCentroCusto.open(row.item)"
                >
                    <rkm-icon icon="door-closed" />
                </rkm-button>

                <rkm-button
                    color="primary"
                    title="Editar"
                    small
                    @click.stop="handleEdit(row)"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    color="danger"
                    title="Excluir"
                    small
                    @click.stop="handleDestroy(row)"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalCentroCusto ref="ModalCentroCusto" />
    </div>
</template>

<script>
// Components.
import ModalCentroCusto from '@/components/cadastro/centro-custo/Modal'

// Mixins.
import { mask, repository, importacaoCns, object, formats } from '@/mixins'

export default {
    components: { ModalCentroCusto },
    mixins: [ mask, repository, importacaoCns, object, formats ],
    props: {
        termosInvalidos: { type: Array, required: true },
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        index: null,
        repositories: {
            municipio: null,
            logradouro: null,
        },
        infraestrutura: {
            infraestruturaId: null,
            unidadeId: null,
            id: null,
            principal: false,
            nome: '',
            telefone: null,
            endereco: {
                estadoId: null,
                municipio: null,
                logradouro: null,
                bairroNome: '',
                cep: '',
                numero: null,
                semNumero: false,
                complemento: '',
                zonaId: null,
            },
            centrosCusto: [],
        },
        fields: [
            {
                key: 'principal',
                label: 'Principal',
                sortable: true,
            },
            {
                key: 'nome',
                label: 'Nome',
                sortable: true,
            },
            {
                key: 'telefone',
                label: 'Telefone',
                sortable: true,
            },
            {
                key: 'endereco.logradouro.tipoNome',
                label: 'Logradouro',
                sortable: true,
            },
            {
                key: 'endereco.numero',
                label: 'Número',
                sortable: true,
            },
            {
                key: 'endereco.logradouro.bairro.nome',
                label: 'Bairro',
                sortable: true,
            },
            {
                key: 'actions',
                label: 'Ações',
                class: 'col-min',
            },
        ],
    }),
    computed: {
        infraestruturas() {
            let infraestruturas = []

            if (this.infraestrutura.unidadeId) {
                infraestruturas = this.form.unidades.find(unidade => unidade.id === this.infraestrutura.unidadeId).infraestruturas
            }

            return infraestruturas
        },
        validations() {

            return {
                nome: {
                    required: !this.infraestrutura.principal,
                    min: 3,
                    max: 255,
                },
                telefone: { required: true, min_max_without_mask: [10, 11] },
                estado: { required: true },
                municipio: { required: true },
                logradouro: { required: true },
                numero: {
                    required: !this.infraestrutura.endereco.semNumero,
                    max: 6
                },
                complemento: {
                    min: 3,
                    max: 100,
                    regex: this.importacaoCns.regexValidacao,
                    termo_invalido: this.termosInvalidos
                },
                zona: { required: true },
                infraestruturaId: { required: true },
            }
        },
        disabledCheckboxPrincipal() {

            const infraestruturaPrincipal = this.model.infraestruturas.find(i => i.principal)

            if (infraestruturaPrincipal) {

                const index = this.model.infraestruturas.indexOf(infraestruturaPrincipal)

                return this.index !== index
            }

            return false
        }
    },
    watch: {
        'infraestrutura.principal': function (principal) {

            this.infraestrutura.nome = principal ? this.model.nomeFantasia : ''
        },
        'infraestrutura.endereco.estadoId': function() {

            this.infraestrutura.endereco.municipio = null
        },
        'infraestrutura.endereco.municipio': function() {

            this.infraestrutura.endereco.logradouro = null
        },
        'infraestrutura.endereco.logradouro': function(logradouro) {

            if (logradouro) {

                this.infraestrutura.endereco.bairroNome = logradouro.bairro.nome
                this.infraestrutura.endereco.cep = this.formatCep(logradouro.cep)
            }
            else {

                this.infraestrutura.endereco.bairroNome = ''
                this.infraestrutura.endereco.cep = ''
            }
        },
        'infraestrutura.endereco.semNumero': function (semNumero) {

            if (semNumero) {

                this.infraestrutura.endereco.numero = null
            }
        },
    },
    methods: {
        async validate() {

            if (this.model.infraestruturas.length === 0) {

                this.showValidationNotification('É obrigatório incluir pelo menos uma infraestrutura.')

                return false;
            }

            return true
        },
        add() {

            this.model.infraestruturas.push(this.clone(this.infraestrutura))

            this.infraestrutura.unidadeId = null
            this.infraestrutura.infraestruturaId = null

            this.resetForm()
        },
        update() {

            this.$set(this.model.infraestruturas, this.index, this.clone(this.infraestrutura))

            this.infraestrutura.unidadeId = null
            this.infraestrutura.infraestruturaId = null

            this.resetForm()

            this.$refs.Table.refresh()
        },
        resetForm() {

            this.index = null

            this.infraestrutura.id = null
            this.infraestrutura.principal = false
            this.infraestrutura.nome = ''
            this.infraestrutura.telefone = null
            this.infraestrutura.endereco.estadoId = null
            this.infraestrutura.endereco.numero = null
            this.infraestrutura.endereco.semNumero = false
            this.infraestrutura.endereco.complemento = ''
            this.infraestrutura.endereco.zonaId = null
            this.infraestrutura.centrosCusto = []

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleEdit({ index, item }) {

            this.index = index

            this.infraestrutura.id = item.id
            this.infraestrutura.unidadeId = item.unidadeId
            this.infraestrutura.infraestruturaId = item.infraestruturaId
            this.infraestrutura.principal = item.principal

            this.$nextTick()
                .then(() => {

                    this.infraestrutura.nome = item.nome
                    this.infraestrutura.telefone = item.telefone
                    this.infraestrutura.endereco.estadoId = item.endereco.estadoId

                    return this.$nextTick()
                })
                .then(() => {

                    this.infraestrutura.endereco.municipio = item.endereco.municipio

                    return this.$nextTick()
                })
                .then(() => {

                    this.infraestrutura.endereco.logradouro = item.endereco.logradouro

                    return this.$nextTick()
                })
                .then(() => {

                    this.infraestrutura.endereco.numero = item.endereco.numero
                    this.infraestrutura.endereco.semNumero = item.endereco.semNumero
                    this.infraestrutura.endereco.complemento = item.endereco.complemento
                    this.infraestrutura.endereco.zonaId = item.endereco.zonaId

                    this.infraestrutura.centrosCusto = item.centrosCusto
                })
        },
        handleDestroy({ index }) {

            const destroy = async () => {

                this.model.infraestruturas.splice(index, 1)

                if (index === this.index) {

                    this.resetForm()
                }
            }

            this.showDeleteConfirmation('Deseja realmente excluir a infraestrutura?', destroy)
        },
        handleUnidadeChange() {
            this.resetForm()

            this.infraestrutura.infraestruturaId = null
        },
        async handleInfraestruturaChange(value) {
            this.resetForm()

            if (value) {
                const infraestruturas = this.form.unidades.find(unidade => unidade.id === this.infraestrutura.unidadeId).infraestruturas

                if (infraestruturas.length > 0) {
                    const infraestrutura = infraestruturas.find(infraestrutura => infraestrutura.id === value)

                    this.infraestrutura.principal = false
                    this.infraestrutura.nome = infraestrutura.nome
                    this.infraestrutura.telefone = infraestrutura.telefone
                    this.infraestrutura.endereco.estadoId = infraestrutura.endereco.logradouro.municipio.estado.id

                    await this.$nextTick()
                    this.infraestrutura.endereco.municipio = infraestrutura.endereco.logradouro.municipio

                    await this.$nextTick()
                    this.infraestrutura.endereco.logradouro = infraestrutura.endereco.logradouro
                    this.infraestrutura.endereco.numero = infraestrutura.endereco.numero
                    this.infraestrutura.endereco.semNumero = infraestrutura.endereco.semNumero
                    this.infraestrutura.endereco.complemento = infraestrutura.endereco.complemento
                    this.infraestrutura.endereco.zonaId = infraestrutura.endereco.zona.id
                }
            }
        },
        clear() {
            this.infraestrutura.unidadeId = null
            this.infraestrutura.infraestruturaId = null

            this.resetForm()
        }
    },
    created() {

        this.repositories.municipio = this.getConectaSusRepository('intranet.municipio')
        this.repositories.logradouro = this.getConectaSusRepository('cadastro.localizacao.logradouro')
    },
}
</script>